import { createSelector } from "reselect";

import getDomain from "../base_getters/get_domain";
import getProjectId from "./get_project_id";
import { FloorTradeBuiltElementCounts } from "../../reducers/domain/reduce_floor_trade_built_element_counts";

const getFloorTradeBuiltElementCounts = createSelector([
  getDomain,
  getProjectId
], (domain, projectId): FloorTradeBuiltElementCounts => {
  return domain.floorTradeBuiltElementCounts?.byFirebaseProjectId?.[projectId] ?? {};
});

export default getFloorTradeBuiltElementCounts;
